/// <amd-module name="Test/AssociateToTestCase/Store/AssociateToTestCaseStore" />
import { ITestCaseResultHolder, AssociateToTestCaseActionHub } from "Actions/AssociateToTestCaseActionHub";
import { IVssPageContext } from "VSS/Platform/Context";
import { Store } from "VSS/Reflux/Store";
import { WorkItem } from 'Wit/Clients/Wit/Contracts/WorkItemTracking';

export interface ITestResultDetails {
    computerName: string;
    testCaseTitle: string;
    testCaseRefId: number;
    startedDate: Date;
    completedDate: Date;
    automatedTestName: string;
    automatedTestStorage: string;
}

export interface IAssociateToTestCaseState {
    loading: boolean;
    showDialog: boolean;
    testResults: ITestResultDetails;
    associationsExist: boolean;
    isAssociated: boolean;
    associatedTestCase: WorkItem;
    workItems: WorkItem[];
    errorMessage?: string;
    associationSaved: boolean;
    associateError: string;
}

export class AssociateToTestCaseStore extends Store {
    private _state: IAssociateToTestCaseState;

    constructor(private _pageContext: IVssPageContext, private _actionHub: AssociateToTestCaseActionHub) {
        super("");
        this._state = this._getInitialState();
        this._actionHub.associateToTestCaseDialog.addListener(this._updateAssociateToTestCaseDialogContent);
        this._actionHub.addAssociateTestCase.addListener(this._addAssociateTestCase);
        this._actionHub.addAssociateTestCaseFailure.addListener(this._addAssociateTestCaseFailure);
        this._actionHub.onDismiss.addListener(this._onDismiss);
        this._actionHub.onError.addListener(this._onError);
    }

    public dispose(): void {
        this._actionHub.onDismiss.removeListener(this._onDismiss);
        this._actionHub.onError.removeListener(this._onError);
    }

    public getState(): IAssociateToTestCaseState {
        return this._state;
    }

    private _getInitialState() {
        return {
            loading: true,
            showDialog: true,
            associationsExist: false,
            isAssociated: false,
            associationSaved: false,
            associateError: ""
        } as IAssociateToTestCaseState;
    }

    private _updateAssociateToTestCaseDialogContent = (testCaseHolder: ITestCaseResultHolder) => {
        if (!!testCaseHolder) {
            this._state.loading = false;
            this._state.showDialog = true;

            if (testCaseHolder.testCaseResult) {
                this._state.testResults = {
                    computerName: testCaseHolder.testCaseResult.computerName ? testCaseHolder.testCaseResult.computerName : "",
                    testCaseRefId: testCaseHolder.testCaseResult.testCaseReferenceId,
                    testCaseTitle: testCaseHolder.testCaseResult.testCaseTitle,
                    startedDate: testCaseHolder.testCaseResult.startedDate,
                    completedDate: testCaseHolder.testCaseResult.completedDate,
                    automatedTestName: testCaseHolder.fullyQualifiedName,
                    automatedTestStorage: testCaseHolder.testCaseResult.automatedTestStorage,
                };

                if(testCaseHolder.workItems.length > 0) {
                    this._state.associationsExist = true;
                    this._state.workItems = testCaseHolder.workItems.slice();
                }
            }
            this.emitChanged();
        }
    }

    private _addAssociateTestCase = (workItem: WorkItem) => {
        this._state.associatedTestCase = workItem;

        if (workItem === null || workItem === undefined) {
            this._state.associateError = "Failed to get TestCaseId"
        }
        else if (workItem.fields["System.WorkItemType"] !== "Test Case") {
            this._state.associateError = "WorkItem is not TestCase"
        }
        else if (workItem.fields["Microsoft.VSTS.TCM.AutomatedTestName"] !== null && workItem.fields["Microsoft.VSTS.TCM.AutomatedTestName"] !== undefined) {
            this._state.associateError = "Association Already Exists";
        }
        else {
            this._state.isAssociated = true;
            this._state.associationsExist = true;
        }

        this.emitChanged();
    };

    private _addAssociateTestCaseFailure = (error: string) => {
        console.error("AddAssociate failed with error: " + error);
        this._state.associateError = error;
        this.emitChanged();
    };

    private _onDismiss = () => {
        this._state.showDialog = false;

        this.emitChanged();
    };

    private _onError = (error: string) => {
        this._state.loading = false;
        this._state.errorMessage = error;

        this.emitChanged();
    };
}